// @flow

const removeTimeZoneFromDateString = (queryParams) => {
  let containsUpdate = false;

  const updatedQueryParams = {
    ...queryParams
  };
  const valuesToUpdate = ["arriving", "leaving"];

  const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/; // 2022-10-12T20:15:00.000Z
  const isoPatternOffset = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/; // 2022-10-12T19:15:00+01:00
  const isoPatternUTCZone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/; // 2022-10-12T20:15:00Z

  const patterns = [isoPattern, isoPatternOffset, isoPatternUTCZone];

  valuesToUpdate.forEach((item) => {
    if (item in queryParams) {
      const match =
        patterns.find((pattern) => pattern.test(queryParams[item])) !==
        undefined;

      if (match) {
        containsUpdate = true;
        updatedQueryParams[item] = queryParams[item].slice(0, 16);
      }
    }
  });

  return containsUpdate ? updatedQueryParams : false;
};

export default removeTimeZoneFromDateString;
